import { Flex, Text, ErrorIcon } from '@fluentui/react-northstar';
import 'COMPONENTS/FullScreenWarning/FullScreenWarning.css'

// renders a fullscreen warning with message
const FullScreenWarning = ({ label }: { label: string }) => {
  return (
    <Flex fill vAlign="center" hAlign="center" column gap="gap.medium">
      <ErrorIcon className='warningSign' />
      <Text content={label} align='center'/>
    </Flex>
  );
};

export default FullScreenWarning;
